module.exports = __webpack_public_path__ + "img/Postmodernisme_Spraaket_i_perioden1.c492d08f.jpg";